import { Pipe, PipeTransform } from '@angular/core';

/**
 * Formats a shift time string from '7:00AM-3:00PM' to '7:00 AM - 3:00 PM'.
 */
@Pipe({
    name: 'shiftTimeFormat',
    standalone: false
})
export class ShiftTimeFormatPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';
    // Split on dash
    const parts = value.split('-');
    if (parts.length !== 2) return value;
    // Insert space before AM/PM if missing
    const formatPart = (part: string) => part.replace(/([AP]M)$/i, ' $1').trim();
    return `${formatPart(parts[0])} - ${formatPart(parts[1])}`;
  }
}
